import { createAction } from 'redux-actions';

import { Actions } from '../constants';

const mapPayload = (pageName = null) => ({ pageName });

const openModal = createAction(Actions.OPEN, mapPayload);

export { openModal };
